import {
    userService
} from '../_services'
import router from '../router'

// importamos las traducciones para gestionar los avisos
// eslint-disable-next-line no-unused-vars
import i18n from '../i18n.js';

const userLocal = JSON.parse(localStorage.getItem('user'))
const countriesLocal = JSON.parse(localStorage.getItem('countries'))


const state = {
    user: (userLocal ? userLocal : null),
    status: {
        loggedIn: (userLocal ? userLocal : null)
    },
    countries: (countriesLocal ? countriesLocal : null),
    userData: null,
    loading: false
}

const actions = {

    login({
        dispatch,
        commit
    }, {
        username,
        password,
        rememberMe
    }) {
        //dispatch('alert/default', 'Espere, conectando...', { root: true })

        commit('loginRequest', {
            username
        })

        userService.login(username, password, rememberMe)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/')
                },
                error => {
                    commit('loginFailure', error)
                    if (error === 'Unauthorized') error = 'Acceso no autorizado'
                    //dispatch('alert/error', { text: error.message, data: error }, { root: true })
                    //dispatch('alert/error', error.message, { root: true });
                }
            ).then(
                // recogemos los paises para tenerlos en memoria
                () => {
                    dispatch('refreshCountries')
                },
                () => {
                    dispatch('refreshUserData')
                }
            )
    },

    logout({
        commit
    }) {

        userService.logout()
        commit('logout')
        router.push('/')
    },
    register({
        dispatch,
        commit
    }, user) {

        commit('registerRequest', user)

        userService.register(user)
            .then(
                user => {

                    commit('registerSuccess', user);
                    router.push('/login')
                    setTimeout(() => {
                        // display success message after route change completes
                        // dispatch('alert/success', 'Registration successful', { root: true })
                    })
                },
                error => {
                    commit('registerFailure', error)
                    // dispatch('alert/error', error, { root: true })
                }
            )

    },

    refreshCountries({
        commit,
        dispatch
    }) {
        commit('getCountriesRequest');
        userService.getCountries()
            .then(
                countries => {
                    commit('getCountriesSuccess', countries)
                },
                error => commit('getCountriesFailure', error)
            );

    },
    refreshUserData({
        state,
        commit,
        dispatch
    }, silent = false) {

        if (silent === false) {

            commit('cargandoDatos', true);
            commit('limpiarDatos');
        }
        /* dispatch('notifier/success', i18n.t('inscribir perros'), {
            root: true
        });  */
        return new Promise((resolve, reject) => {

            let user_id = state.user.id;
            userService.refreshUserData(user_id)
                .then(
                    response => {
                        commit('refreshUserDataOk', response);
                        return resolve(response.data)
                    },
                    error => {
                        commit('refreshUserDataKo', error)
                        dispatch('notifier/error', error, {
                            root: true
                        });
                    }
                );
        })
    }

}


const mutations = {
    cargandoDatos(state) {
        state.loading = true;
    },
    limpiarDatos(state) {
        state.userData = null;
    },
    refreshUserDataOk(state, user) {

        state.userData = user.data;
        state.loading = false;
        // console.log("estado de carga userdata :" + state.loading, user.data)


    },
    refreshUserDataKo(state, error) {

        state.error = error;
        state.userData = null;
        state.status.loggedIn = false;
        state.loading = false;

    },


    loginRequest(state, user) {

        state.status = {
            loggingIn: true
        }
        state.user = user
    },
    loginSuccess(state, user) {

        state.status = {
            loggedIn: true
        }
        state.user = user
    },
    loginFailure(state) {

        state.status = {
            logginError: 401,
            loggedIn: false
        }
        state.user = null
    },
    logout(state) {

        state.status = {}
        state.user = null
    },
    registerRequest(state, user) {
        state.status = {
            registering: true
        }
    },
    registerSuccess(state, user) {
        state.status = {}
    },
    registerFailure(state, error) {
        state.status = {}
    },
    /**
     *  countries
     */
    getCountriesRequest(state) {
        state.countries = {
            loading: true
        };
    },
    getCountriesSuccess(state, countries) {
        state.countries = countries;
    },
    getCountriesFailure(state, error) {
        state.countries = {
            error
        };
    }


}


export const account = {
    namespaced: true,
    state,
    actions,
    mutations
}